<template>
  <div class="project-card">
    <card class="border-0 donate-card" hover shadow>
      <b-link :to="{ path: '/Project-details', query: {q: cardData.id } }">
        <div class="donation-image">
          <img
            :src=" cardData && cardData.logo_id ? (ImageURl+cardData.logo_id) : defaultImage"
            class="img-fluid"
          />
        </div>
        <div class="card-content">
          <h6
            class="text-default text-uppercase"
          >{{cardData && cardData.name ? cardData.name : "No name available"}}</h6>
          <p
            class="description mt-3"
          >{{ cardData && cardData.description ? cardData.description : "No description available"}}</p>
          <div class="donation-amount-new">
            <div class="total-donated d-info">
              {{$t('Total_Received')}} :
              <span>&#8381;{{ cardData && cardData.fund_collected ? cardData.fund_collected : 0}}</span>
            </div>
            <div class="total-spend d-info">
              {{$t('Total_Spend')}} :
              <span>&#8381;{{cardData && cardData.fund_used ? cardData.fund_used : 0}}</span>
            </div>
          </div>
          <!-- <div class="donation-amount">
                     &#8381; <base-progress  type="success" :value="100" label="5000 raised Fund"></base-progress>
          </div>-->
        </div>
      </b-link>
      <div class="card-footer">
        <base-button
          v-b-modal.modal-userInfo
          @click="showCardData()"
          block
          class="footer-btn"
        >{{$t('Contribute_Now')}}!</base-button>
      </div>
    </card>
    <!-- <BankDetails :cardData="cardData"></BankDetails> -->
  </div>
</template>

<script>
// import BankDetails from "./BankDetails";

export default {
  props: ["cardData"],
  //    components: {

  //     BankDetails
  // },
  data() {
    return {
      ImageURl: "http://88.99.171.147:3000/api/file/",
      defaultImage: "/default-image.png"
    };
  },
  mounted() {},

  methods: {
    showCardData() {
      this.$emit("updateSelectedCardData", this.cardData);
      console.log("contri clicked", this.cardData);
    }
  }
};
</script>